import { Component, EventEmitter, Output } from '@angular/core';
import { InputOutputFilter } from '../local-types/InputOutputFilter';

@Component({
  selector: 'app-input-output-filter',
  templateUrl: './input-output-filter.component.html',
  styleUrls: ['./input-output-filter.component.scss']
})
export class InputOutputFilterComponent {
  @Output() public selectionChanged = new EventEmitter<InputOutputFilter>();
  public filter: InputOutputFilter = { isOrder: false, isResult: false, isInvoice: false, isAction: false };

  public hasFilterSelected(): boolean {
    return this.filter && (this.filter.isOrder || this.filter.isResult || this.filter.isInvoice || this.filter.isAction);
  }

  public invokeSelectionChanged(): void {
    this.selectionChanged.emit(this.filter);
  }

  public clearFilters(): void {
    this.filter = { isOrder: false, isResult: false, isInvoice: false, isAction: false };
    this.invokeSelectionChanged();
  }
}
